const StageOrientation = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  NONE: 'none',
};

function getOrientationFromSeatValue(value_) {
  if (!value_) {
    return StageOrientation.NONE;
  }

  const value = value_.toLowerCase();

  if (Object.values(StageOrientation).includes(value)) {
    return value;
  }

  return StageOrientation.NONE;
}

export default StageOrientation;

export {
  getOrientationFromSeatValue,
};



// WEBPACK FOOTER //
// ./src/syos/StageOrientation.js